import { createSlice } from "@reduxjs/toolkit";
import {
  login,
  register,
  detailUser,
  editUser,
  sendEmail,
  sendEmailBooking,
  sendEmailBookings,
  sendEmailPayment,
  becomePartner,
  sendEmailForgetPassword,
  resetPassword,
  changePassword,
  getCookiepolicy,
  getGuidelines,
  getRefundpolicy,
  getTerms,
  getPrivacypolicy,
  uploadSlip,
  sendRefundRequestEmail,
} from "../../API/AuthAPI";

const initialState = {
  isAuthenticated: false,
  user: {},
  token: null,
  emailStatus: "",
  sendEmailStatus: "",
  sendEmailBookingStatus: "",
  sendEmailBookingsStatus: "",
  sendEmailPaymentStatus: "",
  sendRefundRequestEmailStatus: "",
  becomePartnerStatus: "",
  resetPasswordStatus: "",
  changePasswordStatus: "",
  cookiePolicy: [],
  guideLine: [],
  refundPolicy: [],
  terms: [],
  privacyPolicy: [],
  uploadSlipStatus: "",
};

const loadState = () => {
  try {
    const serializedState = localStorage.getItem("authState");
    if (serializedState === null) {
      return initialState;
    }
    return JSON.parse(serializedState);
  } catch (error) {
    return initialState;
  }
};

const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem("authState", serializedState);
  } catch (error) { }
};

export const AuthSlice = createSlice({
  name: "AuthState",
  initialState: loadState(),
  reducers: {
    updateLogin: (state, action) => {
      state.isAuthenticated = action.payload.auth;
      state.user = action.payload.result;
      state.token = action.payload.token;
      saveState(state); // Save state to local storage
    },
    updateRegister: (state, action) => {
      state.register = action.payload;
    },
    updateGetUser: (state, action) => {
      state.user = action.payload.user;
    },
    updateGetCookiePolicy: (state, action) => {
      state.cookiePolicy = action.payload;
    },
    updateGetGuideLine: (state, action) => {
      state.guideLine = action.payload;
    },
    updateGetRefundPolicy: (state, action) => {
      state.refundPolicy = action.payload;
    },
    updateGetTerms: (state, action) => {
      state.terms = action.payload;
    },
    updateGetPrivacyPolicy: (state, action) => {
      state.privacyPolicy = action.payload;
    },
    updateEditUser: (state, action) => {
      state.user = action.payload.user;
    },
    updateSendEmailStatus: (state, action) => {
      state.sendEmailStatus = action.payload;
    },
    updateSendEmailBookingStatus: (state, action) => {
      state.sendEmailBookingStatus = action.payload;
    },
    updateSendRefundRequestEmailStatus: (state, action) => {
      state.sendRefundRequestEmailStatus = action.payload;
    },
    updateSendEmailBookingsStatus: (state, action) => {
      state.sendEmailBookingsStatus = action.payload;
    },
    updateSendEmailPaymentStatus: (state, action) => {
      state.sendEmailPaymentStatus = action.payload;
    },
    updateBecomePartnerStatus: (state, action) => {
      state.becomePartnerStatus = action.payload;
    },
    updateEmailStatus: (state, action) => {
      state.emailStatus = action.payload;
    },
    updateResetPasswordStatus: (state, action) => {
      state.resetPasswordStatus = action.payload;
    },
    updateChangePasswordStatus: (state, action) => {
      state.changePasswordStatus = action.payload;
    },
    updateUploadSlipStatus: (state, action) => {
      state.uploadSlipStatus = action.payload;
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.user = {};
      state.token = null;
      state.cookiePolicy = {};
      localStorage.removeItem("avatarBackgroundColor");
      saveState(state);
    },
  },
});

export const {
  updateLogin,
  updateRegister,
  updateGetUser,
  updateEditUser,
  updateEmailStatus,
  updateSendEmailStatus,
  updateSendEmailBookingStatus,
  updateSendRefundRequestEmailStatus,
  updateSendEmailBookingsStatus,
  updateSendEmailPaymentStatus,
  updateBecomePartnerStatus,
  updateResetPasswordStatus,
  updateChangePasswordStatus,
  logout,
  updateGetCookiePolicy,
  updateGetGuideLine,
  updateGetRefundPolicy,
  updateGetTerms,
  updateGetPrivacyPolicy,
  updateUploadSlipStatus,
} = AuthSlice.actions;

export const LoginNew = (LoginData) => async (dispatch) => {
  try {
    const data = await login(LoginData);
    if (data.status) {
      dispatch(updateLogin(data));
    }
    return data;
  } catch (error) {
    console.error("Login failed. Please try again.", error);
  }
};

export const RegisterNew = (RegisterData) => async (dispatch) => {
  try {
    const data = await register(RegisterData);
    dispatch(updateRegister(data));
    return data;
  } catch (error) {
    console.error("Register failed. Please try again.", error);
  }
};

export const getUserDetail = (token) => async (dispatch) => {
  try {
    const data = await detailUser(token);
    dispatch(updateGetUser(data));
    return data;
  } catch (error) {
    console.error("Failed to fetch user details", error);
    throw error;
  }
};

export const editUserDetail = (editUserData) => async (dispatch) => {
  try {
    const data = await editUser(editUserData);
    dispatch(updateEditUser(data));
    return data;
  } catch (error) {
    console.error("Failed to update user details", error);
    throw error;
  }
};

export const sendEmailForgetPasswordAction = (data) => async (dispatch) => {
  try {
    dispatch(updateEmailStatus("sending"));
    const result = await sendEmailForgetPassword(data);
    if (result.status === "success") {
      dispatch(updateEmailStatus("success"));
    } else {
      dispatch(updateEmailStatus("error"));
    }
    return result;
  } catch (error) {
    console.error("Failed to send email", error);
    dispatch(updateEmailStatus("error"));
    throw error;
  }
};

export const sendEmailPaymentAction = (emailData) => async (dispatch) => {
  try {
    dispatch(updateSendEmailPaymentStatus("sending")); // ตั้งสถานะเริ่มต้น

    const result = await sendEmailPayment(emailData);

    if (result.status === "success") {
      dispatch(updateSendEmailPaymentStatus("success")); // สถานะสำเร็จ
    } else {
      dispatch(updateSendEmailPaymentStatus("error")); // สถานะผิดพลาด
    }

    return result;
  } catch (error) {
    console.error("Failed to send email payment:", error);
    dispatch(updateSendEmailPaymentStatus("error")); // สถานะผิดพลาด
    throw error;
  }
};

export const resetPasswordAction = (resetData) => async (dispatch) => {
  try {
    dispatch(updateResetPasswordStatus("processing"));

    const result = await resetPassword({
      token: resetData.token,
      password: resetData.password,
    });

    if (result.status === "success") {
      dispatch(updateResetPasswordStatus("success"));
    } else {
      dispatch(updateResetPasswordStatus("error"));
    }
    return result;
  } catch (error) {
    console.error("Reset Password failed:", error);
    dispatch(updateResetPasswordStatus("error"));
    throw error;
  }
};

export const changePasswordAction =
  (changePasswordData) => async (dispatch) => {
    try {
      dispatch(updateChangePasswordStatus("processing"));

      const result = await changePassword({
        currentPassword: changePasswordData.currentPassword,
        newPassword: changePasswordData.newPassword,
        token: changePasswordData.token,
      });

      if (result.status === "success") {
        dispatch(updateChangePasswordStatus("success"));
      } else {
        dispatch(updateChangePasswordStatus("error"));
      }
      return result;
    } catch (error) {
      console.error("Change Password failed:", error);
      dispatch(updateChangePasswordStatus("error"));
      throw error;
    }
  };

export const sendEmailAction = (emailData) => async (dispatch) => {
  try {
    dispatch(updateSendEmailStatus("sending")); // ตั้งสถานะเริ่มต้น

    const result = await sendEmail(emailData);

    if (result.status === "success") {
      dispatch(updateSendEmailStatus("success")); // สถานะสำเร็จ
    } else {
      dispatch(updateSendEmailStatus("error")); // สถานะผิดพลาด
    }

    return result;
  } catch (error) {
    console.error("Failed to send email:", error);
    dispatch(updateSendEmailStatus("error")); // สถานะผิดพลาดในกรณีเกิดข้อผิดพลาด
    throw error;
  }
};

export const sendEmailBookingAction = (emailData) => async (dispatch) => {
  try {
    dispatch(updateSendEmailBookingStatus("sending")); // ตั้งสถานะเริ่มต้น

    const result = await sendEmailBooking(emailData);

    if (result.status === "success") {
      dispatch(updateSendEmailBookingStatus("success")); // สถานะสำเร็จ
    } else {
      dispatch(updateSendEmailBookingStatus("error")); // สถานะผิดพลาด
    }

    return result;
  } catch (error) {
    console.error("Failed to send email:", error);
    dispatch(updateSendEmailBookingStatus("error")); // สถานะผิดพลาดในกรณีเกิดข้อผิดพลาด
    throw error;
  }
};

export const sendRefundRequestEmailAction = (emailData) => async (dispatch) => {
  try {
    dispatch(updateSendRefundRequestEmailStatus("sending")); // ตั้งสถานะเริ่มต้น

    const result = await sendRefundRequestEmail(emailData);

    if (result.status === "success") {
      dispatch(updateSendRefundRequestEmailStatus("success")); // ส่งสำเร็จ
    } else {
      dispatch(updateSendRefundRequestEmailStatus("error")); // ส่งไม่สำเร็จ
    }

    return result;
  } catch (error) {
    console.error("Failed to send refund request email:", error);
    dispatch(updateSendRefundRequestEmailStatus("error"));
    throw error;
  }
};

export const sendEmailBookingsAction = (emailData) => async (dispatch) => {
  try {
    dispatch(updateSendEmailBookingsStatus("sending")); // ตั้งสถานะเริ่มต้น

    const result = await sendEmailBookings(emailData);

    if (result.status === "success") {
      dispatch(updateSendEmailBookingsStatus("success")); // สถานะสำเร็จ
    } else {
      dispatch(updateSendEmailBookingsStatus("error")); // สถานะผิดพลาด
    }

    return result;
  } catch (error) {
    console.error("Failed to send email:", error);
    dispatch(updateSendEmailBookingsStatus("error")); // สถานะผิดพลาดในกรณีเกิดข้อผิดพลาด
    throw error;
  }
};

export const becomePartnerAction = (partnerData) => async (dispatch) => {
  try {
    dispatch(updateBecomePartnerStatus("sending")); // ตั้งสถานะเริ่มต้น

    const result = await becomePartner(partnerData);

    if (result.status === "success") {
      dispatch(updateBecomePartnerStatus("success")); // สถานะสำเร็จ
    } else {
      dispatch(updateBecomePartnerStatus("error")); // สถานะผิดพลาด
    }

    return result;
  } catch (error) {
    console.error("Failed to process partnership request:", error);
    dispatch(updateBecomePartnerStatus("error")); // สถานะผิดพลาดในกรณีเกิดข้อผิดพลาด
    throw error;
  }
};

export const getCookiePolicyAction = (token) => async (dispatch) => {
  try {
    const data = await getCookiepolicy(token);
    dispatch(updateGetCookiePolicy(data));
    return data;
  } catch (error) {
    console.error("Failed to fetch user details", error);
    throw error;
  }
};

export const getGuideLineAction = (token) => async (dispatch) => {
  try {
    const data = await getGuidelines(token);
    dispatch(updateGetGuideLine(data));
    return data;
  } catch (error) {
    console.error("Failed to fetch user details", error);
    throw error;
  }
};

export const getRefundPolicyAction = (token) => async (dispatch) => {
  try {
    const data = await getRefundpolicy(token);
    dispatch(updateGetRefundPolicy(data));
    return data;
  } catch (error) {
    console.error("Failed to fetch user details", error);
    throw error;
  }
};

export const getTermsAction = (token) => async (dispatch) => {
  try {
    const data = await getTerms(token);
    dispatch(updateGetTerms(data));
    return data;
  } catch (error) {
    console.error("Failed to fetch user details", error);
    throw error;
  }
};

export const getPrivacyPolicyAction = (token) => async (dispatch) => {
  try {
    const data = await getPrivacypolicy(token);
    dispatch(updateGetPrivacyPolicy(data));
    return data;
  } catch (error) {
    console.error("Failed to fetch user details", error);
    throw error;
  }
};

export const uploadSlipAction = (slipData) => async (dispatch) => {
  try {
    dispatch(updateUploadSlipStatus("uploading")); // เริ่มอัปโหลด

    const result = await uploadSlip(slipData);

    if (result.status === "success") {
      dispatch(updateUploadSlipStatus("success"));
    } else {
      dispatch(updateUploadSlipStatus("error"));
    }

    return result;
  } catch (error) {
    console.error("Failed to upload slip:", error);
    dispatch(updateUploadSlipStatus("error"));
    throw error;
  }
};

export default AuthSlice.reducer;
